import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState, useAppDispatch } from "../../../redux/store";
import { Timeoff } from "../../../types";
import { Palmtree, ChevronRight, Loader2 } from "lucide-react";
import { setSelectedTimeoffForView } from "../../../redux/features/timeoff";
import { useNavigate } from "react-router";
import {
  getApprovalStatusCheck,
  getTimeOffStatusCheck,
} from "../../../utils/timeoff";
import { DateTimeUtil } from "../../../utils";
import { useNavigationHistory } from "../../../hooks/useNavigationHistory";
import { setGlobalBackHandler, clearGlobalBackHandler } from "../../../hooks";

const ViewAllPastTimeOff: React.FC = () => {
  const { isLoadingTimeOffRequests, fetchedTimeoffRequests } = useSelector(
    (state: RootState) => state.timeoff
  );
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { setSourcePath } = useNavigationHistory();
  const today = DateTimeUtil.formatDate(new Date(), "yyyy-MM-dd");

  const [pastRequests, setPastRequests] = useState<Timeoff[]>([]);

  useEffect(() => {
    if (!fetchedTimeoffRequests) return;

    const filtered = fetchedTimeoffRequests
      .filter(
        (request) =>
          request.start_date &&
          DateTimeUtil.IsBeforeWithDayjsUtc(request.start_date, today)
      )
      .sort((a, b) =>
        DateTimeUtil.DifferenceInDaysWithDayjsUtc(b.start_date!, a.start_date!)
      );

    setPastRequests(filtered);
  }, [fetchedTimeoffRequests]);
  
  // Set up navigation history
  useEffect(() => {
    // Set source path for back navigation
    setSourcePath("/m-timeoff");
    
    // Set up global back handler
    setGlobalBackHandler(() => {
      navigate("/m-timeoff");
      return true;
    });
    
    // Clean up when component unmounts
    return () => {
      clearGlobalBackHandler();
    };
  }, [navigate, setSourcePath]);

  const navToTimeoffDetails = (timeoff: Timeoff) => {
    dispatch(setSelectedTimeoffForView(timeoff));
    navigate("/m-timeoff-details");
  };

  const formatDateRange = (start: string, end: string): string =>
    DateTimeUtil.formatDateRangeFancy(start, end);

  return (
    <section className="max-w-md mx-auto px-4 min-h-full">
      <h2 className="text-xl font-bold text-blue-600 mb-2">
        Past Time Off
      </h2>

      {isLoadingTimeOffRequests ? (
        <div className="flex justify-center py-4">
          <Loader2 className="w-6 h-6 animate-spin text-blue-600" />
        </div>
      ) : pastRequests.length > 0 ? (
        <div className="space-y-1">
          {pastRequests.map((request) => (
            <div
              key={request.time_off_request_id}
              className="flex items-center justify-between p-3 cursor-pointer border-b border-stone-200"
              onClick={() => navToTimeoffDetails(request)}
            >
              {/* <div className="flex items-center space-x-3">
                                <div className="p-2 flex items-center justify-center">
                                     {getTimeOffStatusCheck(request.status)}
                                </div>
                                <div>
                                    <p className="text-gray-900 font-medium">
                                        {formatDateRange(request.start_date!, request.end_date!)}
                                    </p>
                                    <div className="flex items-center space-x-1 text-gray-600 text-sm">
                                
                                        <span>{request.hours_requested} {request.track_time_in}</span>
                                    </div>
                                </div>
                            </div> */}
              <div className="flex flex-row items-start space-x-3 ">
                {/* Icon inside a rounded square */}
                {getTimeOffStatusCheck(request.status)}
                <div className="p-2 flex-col w-full items-center justify-center">
                  <div className="text-md font-bold text-blue-600">
                    {request?.category_name}
                  </div>

                  {/* Time Off Details */}
                  <div className="flex  justify-between">
                    <div className="text-gray-900 font-md">
                      {formatDateRange(request.start_date!, request.end_date!)}
                      {/* {getApprovalStatusCheck(request.status)}{" "} */}
                    </div>
                    <div className=" space-x-1 text-gray-600 text-md font-bold">
                      {request?.status}
                    </div>
                  </div>
                </div>
              </div>
              <ChevronRight className="text-gray-400 w-5 h-5" />
            </div>
          ))}
        </div>
      ) : (
        <p className="text-gray-500">No past time-off records available.</p>
      )}
    </section>
  );
};

export default ViewAllPastTimeOff;
